var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissingInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 38802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1077",
    d: "M9.21973 6.75806C9.21973 6.28223 9.56873 5.89648 9.99925 5.89648C10.4298 5.89648 10.7788 6.28223 10.7788 6.75806V10.4472C10.7788 10.923 10.4298 11.3087 9.99925 11.3087C9.56873 11.3087 9.21973 10.923 9.21973 10.4472V6.75806Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 117",
    d: "M10.7896 13.1173C10.7896 13.5996 10.4358 13.9905 9.99951 13.9905C9.56319 13.9905 9.20947 13.5996 9.20947 13.1173C9.20947 12.6351 9.56319 12.2441 9.99951 12.2441C10.4358 12.2441 10.7896 12.6351 10.7896 13.1173Z",
    fill: "#141414"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6207 14.0043L11.1255 2.7543C10.6251 1.88763 9.3742 1.88763 8.87383 2.7543L2.37864 14.0043C1.87827 14.871 2.50374 15.9543 3.50447 15.9543H16.4949C17.4956 15.9543 18.1211 14.871 17.6207 14.0043ZM12.5977 1.9043C11.443 -0.0957025 8.55629 -0.0957037 7.40159 1.9043L0.9064 13.1543C-0.248301 15.1543 1.19507 17.6543 3.50447 17.6543H16.4949C18.8043 17.6543 20.2476 15.1543 19.0929 13.1543L12.5977 1.9043Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingInformation);
export default __webpack_public_path__ + "static/media/missing_information.a8251ee52d0ea0859b6b4bd1372f564e.svg";
export { ForwardRef as ReactComponent };